/**
 * CardModal.js
 */
import $ from 'jquery';
import { gsap, Power2 } from 'gsap';
import { attachCardTypeContent } from './CardTypes';

export default class CardModal {
    constructor(btn, options = {
      duration: .4,
      ease: Power2.easeInOut,
      zIndex: 100,
    }) {
      this.$btn = $(btn);
      this.$element = this.$btn.parents('[data-card-type]');
      this.options = options;
      this.boundKeyUp = this.onKeyUp.bind(this);
      this.$btn.on('click', this.expand.bind(this));
    }

    pruneBoundingClientRect(element){
      const {top, left, width, height} = element.getBoundingClientRect();
      return {top, left, width, height};
    }

    get elementRect(){
      return this.pruneBoundingClientRect(this.$element[0])
    }

    get modalRect(){
      return this.pruneBoundingClientRect(this.$modal[0])
    }

    build() {
      const { 
        textPosition,
        title,
        description,
        linkTitle,
        linkUrl,
        linkTarget,
        showInnerText,
        attachment,
        attachmentCta,
      } = this.$element.data();
      const isTextPosTop = textPosition === 'top';
      const widthClass = isTextPosTop ? attachment ? 'md:w-3/5' : 'md:max-w-810px' : '';

      const description_full = this.$element.find('.description_full').html();

      this.$clone = this.$element.clone();
      this.$clone.css({
        position: 'absolute',
        ...this.elementRect,
        listStyle: 'none',
        transition: 'none',
        transform: 'none',
        maxWidth: 'none',
        top: 0,
        left: 0,
      }).removeClass('shadow');

      this.$modalContainer = $(`<div tabindex="0" class="fixed flex items-center justify-items-center top-0 left-0 h-full w-full p-3 md:p-8 lg:p-12 overflow-auto" />`);
      this.$modalContainer.css({
        zIndex: this.options.zIndex,
      })

      this.$modal = $(`<div role="dialog" tabindex="0" class="relative m-auto w-full max-w-screen-xl max-h-4/5 sm:max-h-auto outline-none modal-content ${isTextPosTop ? 'modal-content-text-top' : ''}" />`);
      this.$modalContent = $(`<div class="h-auto w-full flex flex-col md:flex-${isTextPosTop ? 'col' : 'row'}-reverse"/>`);
      
      const $modalWrapper = $(`<div tabindex="0" class="overflow-hidden bg-white relative rounded-lg shadow h-full w-full" />`);
      const $modalContentAsset = $(`<div class="flex-1 relative" />`);
      const $modalContentAssetContainer = $(`<div class="relative ${showInnerText && !isTextPosTop ? 'pt-270/317' : 'pt-9/16'}"/>`);
      const $modalContentAssetWrapper = $(`<div class="absolute top-0 left-0 w-full h-full"/>`);
      $modalContentAssetContainer.append($modalContentAssetWrapper)
      $modalContentAsset.append($modalContentAssetContainer)

      attachCardTypeContent(this.$element, $modalContentAssetWrapper[0], 'card-modal');

      this.$modalContent.append($modalContentAsset);

      if(showInnerText){
        let html = '';
        if(title) {
          html += `<h4 class="mb-1 lg:mb-2 text-24 lg:text-36 font-benton-comp ${widthClass}">${title}</h4>`
        }
        if(description_full) {
          html += `<p class="text-16 ${isTextPosTop ? `${widthClass} md:inline-block` : ''}">${description_full}</p>`
        }else if(description){
          html += `<p class="text-16 ${isTextPosTop ? `${widthClass} md:inline-block` : ''}">${description}</p>`
        }

        if(linkUrl || linkTitle ) {
          html += `<a href="${linkUrl}" target="${linkTarget}" class="bg-white shadow text-black py-2 inline-block px-4 rounded-full mt-2 transition duration-300 ease-in-out hover:bg-orange hover:text-white">${linkTitle}</a>`
        }
        if(attachment) {
          html += `<a href="${attachment}" target="_blank" rel="noopener" class="block sm:inline-block align-top ${isTextPosTop ? 'md:absolute md:bottom-0 md:right-0' : ''} mt-4 shadow text-black text-center py-2 px-4 rounded-full mr-2 hover:bg-orange transition ease-out duration-300">${attachmentCta}</a>`
        }
        this.$modalContent.append($(`<div class="p-4 lg:p-6 ${!isTextPosTop ? 'md:w-108/317' : ''} bg-white"><div class="relative flex h-full items-center"><div class="expand-card-text">${html}</div></div></div>`));
      }

      this.$modalCloseBtn = $(`<button block class="w-10 h-10 transition duration-300 ease-in-out rounded-full shadow bg-orange hover:bg-white text-white hover:text-orange absolute -mt-12 md:-mt-5 md:-mr-5 top-0 right-0" type="button">
        <svg class="fill-current" viewBox="0 0 108 108" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M67.435 43.3933C68.2161 42.6123 68.2161 41.346 67.435 40.5649C66.654 39.7839 65.3877 39.7839 64.6066 40.5649L54 51.1715L43.3934 40.5649C42.6123 39.7839 41.346 39.7839 40.565 40.5649C39.7839 41.346 39.7839 42.6123 40.565 43.3933L51.1716 53.9999L40.565 64.6065C39.7839 65.3876 39.7839 66.6539 40.565 67.435C41.346 68.216 42.6123 68.216 43.3934 67.435L54 56.8284L64.6066 67.435C65.3876 68.216 66.654 68.216 67.435 67.435C68.2161 66.6539 68.2161 65.3876 67.435 64.6065L56.8284 53.9999L67.435 43.3933Z"></path>
        </svg>
      </button>`);

      this.$modalBg = $('<div class="fixed top-0 left-0 h-full w-full" />');
      $modalWrapper.append(this.$clone);
      $modalWrapper.append(this.$modalContent);
      this.$modal.append($modalWrapper);
      this.$modal.append(this.$modalCloseBtn);
      this.$modalContainer.append(this.$modalBg);
      this.$modalContainer.append(this.$modal);
      this.$modalContainer.appendTo('body');

      $(document).on('keyup', this.boundKeyUp);
      $('body').css({'overflow': 'hidden'});
      this.$modalBg.on('click', this.close.bind(this));
      this.$modalCloseBtn.on('click', this.close.bind(this));
    }
  
    expand() {
      this.build();
      const modalProps = this.modalRect;
      const { duration, ease } = this.options;

      this.$modal.css({
        position: 'fixed',
        ...this.elementRect,
      })
      this.timeline = gsap.timeline({
        onComplete: () => this.$modal.trigger('focus')
      });

      const clonedImage = this.$clone.find('img.absolute');
      if(clonedImage.length > 0){
        this.timeline.to(this.$clone.find('img.absolute').parent(), {
          duration,
          paddingBottom: `100%`,
          clearProps: 'all',
          ease
        }, 0);
      }

      this.timeline.fromTo(this.$modalBg, 
        {
          backgroundColor: 'rgba(255, 255, 255, 0)',
        },{
        duration,
        backgroundColor: 'rgba(255, 255, 255, .8)',
        ease
      }, 0);
      this.timeline.to(this.$clone, {
        duration,
        autoAlpha: 0,
        ease
      }, 0);
      this.timeline.to(this.$modal, {
        duration,
        ...modalProps,
        clearProps: 'all',
        ease
      }, 0);
      this.timeline.from(this.$modalCloseBtn, {
        duration,
        autoAlpha: 0,
        ease
      }, 0);
      this.timeline.from(this.$modalContent, {
        duration,
        autoAlpha: 0,
        ease
      }, duration);
    }

    close() {
      if (window.currentVimeoPlayer) {
        window.currentVimeoPlayer.pause();
      }
      const { duration, ease } = this.options;
      if (this.timeline) {
        this.timeline.kill();
      }
      this.timeline = gsap.timeline({
        onComplete: this.remove.bind(this),
      });
      this.timeline.to(this.$modalBg, {
        duration,
        backgroundColor: 'rgba(255, 255, 255, 0)',
        ease
      }, 0);
      this.timeline.to(this.$modalContent, {
        duration,
        autoAlpha: 0,
        ease
      }, 0);
      this.timeline.to(this.$clone, {
        duration,
        autoAlpha: 1,
        ease
      }, duration);
      this.timeline.fromTo(this.$modal, {
        position: 'fixed',
        ...this.modalRect,
      }, {
        ...this.elementRect,
        ease
      }, duration);
      this.timeline.to(this.$modalCloseBtn, {
        duration,
        autoAlpha: 0,
        ease
      }, duration);
    }

    remove() {
      this.$modalContainer.remove();
      $('body').css({'overflow': ''});
      $(document).off('keypress', this.boundKeyboardPress);
      this.timeline = null;
      this.$btn.trigger('focus');
    }

    onKeyUp(e) {
      e.preventDefault();
      if (e.keyCode === 27) {
        this.close();
      }
    }
}
